import { InputWrapper } from "./styled";

export default InputWrapper;
